import React from "react";
import ShopeeWorkspace from "../../../containers/pages/shopee/ShopeeWorkspace";

const ShopeePage = () => <ShopeeWorkspace />;

export default ShopeePage;
